export const CMS_COMPONENT_YOUTUBE = 'youtube';
export const YOUTUBE_VIDEO = 'youtube-video';
export const CMS_MEDIA_CONTAINER = 'cms-media-container';

export { initAllCmsYoutubeVideos } from './youtubeVideo';
